const GLOBALS = {
  CWA_PUBLIC_URL: "https://tripsomania.com",
  RAILS_PUBLIC_URL: "https://old.tripsomnia.com",
  RAILS_PACKS_URL: "https://old.tripsomnia.com/assets",
  RAILS_API_URL: "https://old.tripsomnia.com/api/partner",
  RAVEN_PUBLIC_DSN: "https://5f022629191345d1940facc740476f1e@sentry.io/1399403",
  GOOGLE_PUBLIC_API_KEY: "AIzaSyD2pladvw9VThlS2pwrBigPS4o7QuJm-QQ",
  STRIPE_KEY: "pk_live_xLvxa3HD6BaXwvZwBuiectZV",
  LOCAL_STORAGE_AUTH_TOKEN_PATH: "socialtravel-partnerapp-production/auth/user.auth_token"
};

export default GLOBALS;



// WEBPACK FOOTER //
// ./src/config/globals.production.js